// extracted by mini-css-extract-plugin
module.exports = {"checkBoxGroup":"styles_checkBoxGroup__1S7iD","checkBoxBody":"styles_checkBoxBody__349Rt","checkBoxGroupOption":"styles_checkBoxGroupOption__02DlG"};